export default __webpack_public_path__ + "static/media/32.59249d5d.jpg";